/**
 * SFCC-11498 (ARTICLES-12) — editor seed for the `articleCards` custom-grid list.
 * Mirrors composable's `articleCardDefault`: a single ArticleCard Builder Element
 * so the visual editor shows one card when an author first enables custom mode.
 */
export const articleCardDefault = {
  "@type": "@builder.io/sdk:Element",
  "@version": 2,
  component: {
    name: "ArticleCard",
    options: {
      ctaText: "Read Article",
    },
  },
  responsiveStyles: {
    large: {
      width: "100%",
    },
  },
};
